// Media Player
// 

JLM.MD.MediaPlayer = function( container ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Constants: Private _______________________________________________________
	
	// HTML structure
	const TEMPLATE_HTML = '<div><div class="jp-frame"><div class="jp-media"></div><div class="jp-overlay"><svg class="ready"><use xlink:href="#jl_icon_play"></use></svg><svg class="play"><use xlink:href="#jl_icon_play"></use></svg><svg class="pause"><use xlink:href="#jl_icon_pause"></use></svg></div><div class="jp-title"><h1></h1><p></p></div></div><div class="jp-gui"><div class="jp-interface"><div class="jp-controls"><button class="jp-play" role="button" tabindex="0"><svg class="play"><use xlink:href="#jl_icon_play"></use></svg><svg class="pause"><use xlink:href="#jl_icon_pause"></use></svg></button></div><div class="jp-timeline"><div class="jp-progress"><div class="jp-seek-bar"><div class="jp-play-head"></div><div class="jp-play-bar"></div></div></div><div class="jp-options"><div class="jp-timer"><div class="jp-current-time" role="timer" aria-label="time">00:00</div><div class="jp-total-time" role="timer" aria-label="total">00:00</div></div><div class="jp-actions"><button class="jp-full-screen" role="button" tabindex="0"><span class="label">Fullscreen</span></button><button class="jp-download" role="button" tabindex="0"><svg><use xlink:href="#jl_icon_download"></use></svg><span class="label">Download MP3</span></button></div></div></div></div></div><div class="jp-no-solution"><p><strong>Update Required</strong>To play the media you will need to either update your browser to a recent version or update your <a href="http://get.adobe.com/flashplayer/" target="_blank">Flash plugin</a>.</p></div></div>';
	
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let time_total;
	
	
	
	// Variables: Public ________________________________________________________
	
	// Media data
	INSTANCE.src = null;
	INSTANCE.poster = null;
	INSTANCE.talent_id = null;
	INSTANCE.header = null;
	INSTANCE.description = null;
	
	// References
	INSTANCE.media = null;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Get data
		INSTANCE.src = $('#jl_media_src', container).attr('content');
		INSTANCE.poster = $('#jl_media_poster', container).attr('content');
		INSTANCE.talent_id = $('#jl_media_talent_id', container).attr('content');
		INSTANCE.header = $('#jl_media_header', container).attr('content');
		INSTANCE.description = $('#jl_media_description', container).attr('content');
		
		// Temp references
		let frame, overlay, title, title_header, title_description, 
			uinterface, but_play, timeline, playhead, options;
		
		// Create structure
		$( TEMPLATE_HTML ).appendTo( container );
		
		// Retrieve references
		frame = $('.jp-frame', container);
		INSTANCE.media = $('.jp-media', frame);
		overlay = $('.jp-overlay', frame);
		title = $('.jp-title', frame);
			title_header = $('h1', title);
			title_description = $('p', title);
		uinterface = $('.jp-gui .jp-interface', container);
			but_play = $('.jp-controls button.jp-play', uinterface);
			timeline = $('.jp-timeline', uinterface);
				playhead = $('.jp-play-head', timeline);
				options = $('.jp-options', timeline);
					time_total = $('.jp-timer .jp-total-time', options);
		
		// Set content
		if ( INSTANCE.header ) {
			title_header.html( INSTANCE.header );
		} else {
			title_header.remove();
		}
		if ( INSTANCE.description ) {
			title_description.html( INSTANCE.description );
		} else {
			title_description.remove();
		}
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Update total time
	// 
	INSTANCE.setDuration = function( time_duration ) {
		let time_hours = Math.floor( time_duration / 60 ),
			time_mins = Math.round( time_duration - ( time_hours * 60 )),
			time_display = time_hours.zeroPad(2) + ':' + time_mins.zeroPad(2);
		time_total.html( time_display );
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};


// Static: Methods ______________________________________________________________

// Launch a video player
// 
JLM.MD.MediaPlayer.launchVideoPlayer = function( talent_id, talent_url, division_type ) {
	const SIZE_WIDTH = 680,
		  SIZE_HEIGHT = 512;
	
	// Track
	JLM.MT.trackEvent('Video', {
		event_category: 'Media',
		event_label: JSON.stringify({
			talent: talent_id,
			division: division_type
		})
	});
	
	// Launch player
	let params = 'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=' + SIZE_WIDTH + ',height=' + SIZE_HEIGHT;
	const win_player = window.open('/player/video/' + talent_url + '/' + division_type, 'media_player', params);
};


// Launch an audio player
// 
JLM.MD.MediaPlayer.launchAudioPlayer = function( talent_id, talent_url, type ) {
	const SIZE_WIDTH = 680,
		  SIZE_HEIGHT = 262;
	
	// Track
	JLM.MT.trackEvent('Audio', {
		event_category: 'Media',
		event_label: JSON.stringify({
			talent: talent_id,
			type: type
		})
	});
	
	// Launch player
	let url = '/player/audio/' + talent_url;
		if ( type ) url += '/' + type;
	const win_player = window.open(url, 'media_player', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=' + SIZE_WIDTH + ',height=' + SIZE_HEIGHT);
};

